import { request, qs } from '../services/api';
import { useQuery, useMutation, invalidateKeys } from './query';

// Build the 5 standard REST calls for a resource base path, e.g. "/states".
export function makeCrud(base) {
  return {
    list: (params) => request(`${base}${qs(params)}`),
    get: (id) => request(`${base}/${id}`),
    create: (body) => request(base, { method: 'POST', body }),
    update: (id, body) => request(`${base}/${id}`, { method: 'PUT', body }),
    remove: (id) => request(`${base}/${id}`, { method: 'DELETE' }),
  };
}

// Build query + mutation hooks for a crud object. key = cache key (usually the resource slug).
export function makeCrudHooks(key, crud) {
  const useList = (params) => useQuery({ queryKey: [key, params], queryFn: () => crud.list(params) });
  const useCreate = (opts = {}) =>
    useMutation({ mutationFn: (body) => crud.create(body), onSuccess: () => { invalidateKeys([key]); opts.onSuccess?.(); }, onError: opts.onError });
  const useUpdate = (opts = {}) =>
    useMutation({ mutationFn: ({ id, body }) => crud.update(id, body), onSuccess: () => { invalidateKeys([key]); opts.onSuccess?.(); }, onError: opts.onError });
  const useRemove = (opts = {}) =>
    useMutation({ mutationFn: (id) => crud.remove(id), onSuccess: () => { invalidateKeys([key]); opts.onSuccess?.(); }, onError: opts.onError });
  return { useList, useCreate, useUpdate, useRemove };
}
